
import React from 'react';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';
import { Router, Switch, Route, Redirect } from 'react-router-dom';
import styled, { ThemeProvider } from 'styled-components';
import { PersistGate } from 'redux-persist/integration/react'

import { OnlineProvider } from 'op/components/offline';
import { withLogout } from 'op/components/auth';

import Page from 'op/components/page';

import Login from './login';
import PersonSearch from './person/search';
import PersonInfoCard from './person/info-card';
import PersonReports from './person/reports';

import ReportCreate from './report/create';
import ReportCreateBulk from './report/create-bulk';
import ReportPending from './pending';
import ReportEdit from './report/edit';
import ReportView from './report/view';

import CreateButton from 'op/components/report/create-button';
import { withAction } from 'op/components/permission';
import STPItems from './stp/items';
import STPItemInfoCard from './stp/info-card';
import StpTests from './stp/tests/stp-tests.container';
import StpForm from './stp/form/form.container';
import StpThresholds from './stp/thresholds/thresholds.container';
import PrototypeForm from './prototype-form';

import FormsItems from './forms/items/forms-items.container';
import FormItemReports from './forms/itemReports/formitem-reports.container';
import FormItemInfoCard from './forms/info-card/info-card.container';
import FormsForm from './forms/form/form.container';

import AuditList from './audit/list';
import AuditDetails from './audit/details';
import AuditForm from './audit/form';

export default ({ container }) => (
	<Provider store={container.resolve('store')}>
		<OnlineProvider>
			<PersistGate loading={"Loading...."} persistor={container.resolve('persistor')}>
				<ThemeProvider theme={container.resolve('config').THEME}>
					<Router history={container.resolve('history')}>
						<Switch>
							<Route exact path="/login" component={Login} />
							<Route exact path="/logout" component={withLogout(Login)} />

							<Page>
								<Switch>
									<Route exact path="/prototype" component={PrototypeForm} />
									<Route exact path="/" component={PersonSearch} />
									<Route exact path="/pending" component={ReportPending} />
									<Route path="/stp" >
										<Route exact path="/stp" component={STPItems} />
										<Route path="/stp/:item_id" component={STPItemInfoCard} />
										<Route exact path="/stp/:item_id/tests" component={StpTests} />
										<Route exact path="/stp/:item_id/tests/new" component={StpForm} />
										<Route exact path="/stp/:item_id/tests/:test_id/edit" component={StpForm} />
									</Route>
									<Route path="/forms">
										<Route exact path="/forms" component={FormsItems} />
										<Route path="/forms/:item_id" component={FormItemInfoCard} />
										<Route exact path="/forms/:item_id/records" component={FormItemReports} />
										<Route exact path="/forms/:item_id/records/new" component={FormsForm} />
									</Route>
								<Route path="/audit">
									<Switch>
										<Route exact path="/audit" component={AuditList} />
										<Route exact path="/audit/new" component={AuditForm} />
										<Route exact path="/audit/:audit_id" component={AuditDetails} />
									</Switch>
								</Route>
									<Route exact path="/stpthresholds" component={StpThresholds} />

									<Route path="/person">
										<div>
											<Route path="/person/:person_id" component={PersonInfoCard} />
											<Route exact path="/person/:person_id" component={PersonReports} />
											<Route exact path="/person/:person_id" component={withAction('report', 2)(CreateButton)} />
											<Route exact path="/person/:person_id/report" component={ReportCreate} />
											<Route exact path="/person/:person_id/report/:report_id" component={ReportView} />
											<Route exact path="/person/:person_id/report/:report_id/edit" component={ReportEdit} />

										</div>
									</Route>

									<Route exact path="/report/bulk" component={withAction('report', 2)(ReportCreateBulk)} />

									<Redirect to='/' />
								</Switch>
							</Page>
						</Switch>
					</Router>
				</ThemeProvider>
			</PersistGate>
		</OnlineProvider>
	</Provider>
);
